export default __webpack_public_path__ + "static/model-hair-quiz-12a4e249619acc158d4b981d3b3e1f94.webp";